export const AgentState = {
  Undefined: 'Undefined',
  NotActiveYet: 'NotActiveYet',
  Active: 'Active',
  ExpiringToday: 'ExpiringToday',
  Expired: 'Expired',
};
